module.exports = __webpack_public_path__ + "img/poly-3.d9b6c27e.png";